import { configureStore, ThunkAction, Action, getDefaultMiddleware } from '@reduxjs/toolkit'
import { routerMiddleware } from 'connected-react-router'
import createRootReducer from './rootReducer'
import { createBrowserHistory } from 'history'
import { accessLog } from './middlewares/accessLog'

export const history = createBrowserHistory()
const store = configureStore({
  reducer: createRootReducer(history),
  middleware: [
    routerMiddleware(history),
    accessLog,
    ...getDefaultMiddleware({
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      // },
      // storeのサイズが大きすぎて警告が出るので無効化
      serializableCheck: false,
      immutableCheck: false,
    }),
  ],
})

// store がファイル的に修正された際のホットリロード
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    const newRootReducer = require('./rootReducer').default
    // wait fix bug https://github.com/rt2zz/redux-persist/issues/1140
    store.replaceReducer(newRootReducer)
  })
}

// state, action, thunk の定義
export type AppState = ReturnType<ReturnType<typeof createRootReducer>>
export type AppDispatch = typeof store.dispatch
export type AppThunk = ThunkAction<void, AppState, null, Action<string>>

export default store
